<template>
  <div class="company-profile-wrapper">
    <div class="tab-options"></div>

    <multipane class="custom-resizer" layout="vertical">
      <!-- company-profile display -->
      <div class="company-profile-container" v-animate-css="'fadeIn'">
        <div class="company-profile-header">
          <label class="title">Public information</label>
          <div class="company-profile-brand">
            <h2 class="company-name">
              {{ user.company_info.company_name | validate }}
            </h2>
            <div class="location-data">
              <span>{{ user.company_info.address | validate }}</span>
            </div>
            <div class="contact-data">
              <span v-if="user.company_info.phone">{{
                user.company_info.phone | validate
              }}</span>
              <span v-if="user.company_info.email" class="separator">|</span>
              <span v-if="user.company_info.email">{{
                user.company_info.email | validate
              }}</span>
            </div>
            <p
              class="company-desc"
              v-if="user.company_info.description"
              v-html="user.company_info.description"
            ></p>
            <div class="company-profile-option">
              <button class="edit-btn" @click="navigateTocompanySettings()">
                Edit Company Profile
              </button>
            </div>
          </div>
          <div class="company-profile-options"></div>
        </div>
        <div class="company-profile-body" style="margin-bottom: 10px">
          <ul class="consultants-items" v-if="user.consultants.length > 0">
            <li class="consultants-starter">
              <div class="consultants-item-header">
                <label>Consultants</label>
              </div>
            </li>

            <draggable
              draggable=".consultants-item"
              v-model="user.consultants"
              v-bind="dragOptions"
              @start="isDragging = true"
              @end="onDragEnd"
              :move="setDragInfo"
            >
              <transition-group type="transition" :name="'flip-list'">
                <li
                  class="consultants-item"
                  v-for="(item, index) in user.consultants"
                  :key="index"
                >
                  <panel-expand :expand="false">
                    <template v-slot:header>
                      <div class="consultants-item-header">
                        <div class="consultants-item-brand">
                          <img
                            v-if="item.profile_picture"
                            :src="
                              $fullUrl(
                                'images/profiles/' + item.profile_picture
                              )
                            "
                            alt
                          />
                          <img
                            v-else
                            src="@/assets/icons/logo_avatar.svg"
                            alt
                          />
                        </div>
                        <div class="content">
                          <div class="title">
                            <label
                              >{{ item.first_name | validate }}
                              {{ item.last_name | validate }}</label
                            >
                          </div>
                          <span v-if="$validateData(item.profile.address)">{{
                            item.profile.address | validate
                          }}</span>
                          <div
                            class="date"
                            v-if="
                              $validateDateTime(item.profile.available_from)
                            "
                          >
                            {{ item.profile.available_from | formatDate }}
                          </div>
                          <div  class="date" v-else>Not Available</div>
                        </div>
                      </div>
                    </template>
                  </panel-expand>
                </li>
              </transition-group>
            </draggable>
          </ul>
          <div class="empty-widget" v-else>
            <div class="empty-widgetheader">
              <label>Consultants</label>
            </div>
            <div class="empty-widget-body">
              <p>
                You have not yet added any consultants
                <!-- <br />Click below to add one -->
              </p>
              <!-- <button class="add-btn">Add a member</button> -->
            </div>
          </div>
        </div>
        <div class="company-profile-body">
          <ul class="project-items" v-if="user.featured_projects.length > 0">
            <li class="project-starter">
              <div class="project-item-header">
                <label>Project</label>
              </div>
            </li>
            <li
              class="project-item"
              v-for="(item, i) in user.featured_projects"
              :key="i"
            >
              <panel-expand :expand="false">
                <template v-slot:header>
                  <div class="project-item-header">
                    <div class="project-item-brand">
                      <img src="@/assets/icons/projects_icon.svg" alt />
                    </div>
                    <div class="content">
                      <div class="title-row">
                        <label>{{ item.name | validate }}</label>
                        <span v-if="item.address">{{
                          item.address | validate
                        }}</span>

                        <span class="date">
                          <span v-if="item.from">{{
                            item.from | formatDate | validate
                          }}</span>
                          <span class="separator" v-if="item.from && item.to"
                            >-</span
                          >
                          <span v-if="item.to">{{
                            item.to | formatDate | validate
                          }}</span>
                        </span>
                      </div>
                      <div class="options">
                        <div class="btns">
                          <span v-if="item.verified" class="verified-status"
                            >Verified</span
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
              </panel-expand>
            </li>
          </ul>
          <div class="empty-widget" v-else>
            <div class="empty-widgetheader">
              <label>Projects</label>
            </div>
            <div class="empty-widget-body">
              <p>
                You have not yet added any project
                <!-- <br />Click below to add one -->
              </p>
              <!-- <button class="add-btn">Add a project</button> -->
            </div>
          </div>
        </div>
      </div>
      <!-- End -->
      <multipane-resizer></multipane-resizer>
      <!-- Skills widget -->
      <div class="skills-section" :style="{ flexGrow: 1 }">
        <ul class="skills-items">
          <li class="skills-starter">
            <div class="skills-item-header">
              <label>Skills</label>
            </div>
          </li>
        </ul>
        <div class="skills-widget">
          <div class="skills_content__wrapper">
            <!-- Tools -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Tools</label>
              </div>
              <div class="skill_box_body" v-if="user.skills.tools.length > 0">
                <div
                  class="row__item"
                  v-for="(item, i) in user.skills.tools.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.priority"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You haven't any tool yet</p>
                </div>
              </div>
            </div>
            <!-- Competence -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Competences</label>
              </div>
              <div
                class="skill_box_body"
                v-if="user.skills.competences.length > 0"
              >
                <div
                  class="row__item"
                  v-for="(item, i) in user.skills.competences.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.priority"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You haven't any competence yet</p>
                </div>
              </div>
            </div>
            <!-- Roles -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Roles</label>
              </div>
              <div class="skill_box_body" v-if="user.skills.roles.length > 0">
                <div
                  class="row__item"
                  v-for="(item, i) in user.skills.roles.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.priority"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You haven't any role yet</p>
                </div>
              </div>
            </div>
          </div>
          <div class="next_skills_content__wrapper">
            <!-- Domain -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Domains</label>
              </div>
              <div class="skill_box_body" v-if="user.skills.domains.length > 0">
                <div
                  class="row__item"
                  v-for="(item, i) in user.skills.domains.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.priority"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You haven't any domain yet</p>
                </div>
              </div>
            </div>
            <!-- Laguage -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Languages</label>
              </div>
              <div
                class="skill_box_body"
                v-if="user.skills.languages.length > 0"
              >
                <div
                  class="row__item"
                  v-for="(item, i) in user.skills.languages.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.lang.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.level"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You haven't any language yet</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </multipane>
    <!-- Setting modal -->
    <Settings
      @onClose="onUpdateProfile()"
      @onCancel="show_settings_modal = false"
      v-if="show_settings_modal"
    ></Settings>
  </div>
</template>

<script>
import panelExpand from "@/components/Partials/panelExpand";
import { eventBus } from "@/main";
import draggable from "vuedraggable";
import Settings from "@/components/Company/Settings.vue";

export default {
  name: "genelar-info-profile",
  components: {
    panelExpand,
    draggable,
    Settings,
  },
  props: {},
  data: () => {
    return {
      show_settings_modal: false,
      user: {
        company_info: {},
        manager_info: {},
        manager_profile: {},
        consultants: [],
        projects: [],
        featured_projects: [],
        skills: {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        },
      },
      isDragging: false,
      consultant_drag_details: {
        draggedContext: {},
        relatedContext: {},
      },
    };
  },
  mounted() {
    let vm = this;
    vm.getStartData();
  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  methods: {
    onUpdateProfile() {
      let vm = this;
      vm.show_settings_modal = false;
      vm.getStartData();
    },
    navigateTocompanySettings() {
      let vm = this;
      vm.show_settings_modal = true;
    },
    setDragInfo({ draggedContext, relatedContext }) {
      this.consultant_drag_details.draggedContext = draggedContext;
      this.consultant_drag_details.relatedContext = relatedContext;
    },
    onDragEnd(ev) {
      let vm = this;
      let start_order = vm.consultant_drag_details.draggedContext.index;
      let end_order = vm.consultant_drag_details.draggedContext.futureIndex;
      let id = vm.consultant_drag_details.draggedContext.element.id;
      let direction = "";
      if (start_order < end_order) {
        direction = "down";
      } else {
        direction = "up";
      }
      //Send data
      vm.$store
        .dispatch("COMPANY_CONSULTANT_SAVE_PRIOLITY", {
          start_order: start_order,
          end_order: end_order,
          id: id,
          direction: direction,
        })
        .then((responce) => {
          vm.getProfileData();
        });
    },
    getStartData() {
      let vm = this;
      vm.$store
        .dispatch("GET_ME_USER_COMPANY")
        .then((responce) => {
          vm.user = responce.data;
          let skills = vm.processSkills(vm.user.skills);
          vm.user.consultants = vm.user.consultants
            .filter((item) => {
              return item.profile;
            })
            .sort((start, end) => {
              return start.order - end.order;
            });
          eventBus.$set(vm.user, "skills", skills);
        })
        .catch((error) => {});
    },
    processSkills(skills_data) {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      if (skills_data && skills_data.length > 0) {
        skills_data.forEach((skill) => {
          skill.tools.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.tools.push(obj);
          });
          skill.domains.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.domains.push(obj);
          });
          skill.competences.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.competences.push(obj);
          });
          skill.roles.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.roles.push(obj);
          });
          skill.languages.forEach((item) => {
            if (item.lang) {
              let obj = {
                lang: { name: item.lang.name },
                level: parseInt(item.level),
              };
              skills.languages.push(obj);
            }
          });
        });
      }
      return skills;
    },
  },
};
</script>
<style lang="scss" scoped>
.company-profile-wrapper {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-right: 8px;
  position: relative;
  @media (min-width: 300px) and (max-width: 630px) {
    padding-right: 0px;
  }
  .company-profile-container {
    min-width: calc(100% - 400px);
    width: 100%;
    @media (min-width: 300px) and (max-width: 630px) {
      margin-bottom: 10px;
    }
    .company-profile-header {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      margin-bottom: 10px;
      .title {
        font-size: 16px !important;
        margin-bottom: 16px;
        display: none;
        @media (min-width: 300px) and (max-width: 630px) {
          display: block;
        }
      }
      .company-profile-brand {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @media (min-width: 300px) and (max-width: 630px) {
          border-radius: 4px;
          border: 1px solid #ddd;
          padding: 15px;
        }
        .company-name {
          font-size: 20px;
        }
        .location-data {
          margin: 0px 20px;
          color: #707070;
        }
        .contact-data {
          .separator {
            margin: 0px 20px;
          }
        }
        img {
          width: 60px;
          height: 60px;
          object-fit: contain;
          margin-bottom: 10px;
          border-radius: 50%;
        }
        span {
          font-family: "AvenirBook";
          font-size: 14px;
          margin-bottom: 10px;
        }
        p.company-desc {
          font-size: 14px;
          line-height: 20px;
          font-family: "AvenirBook";
          margin: 10px 50px 10px 50px;
          @media (min-width: 300px) and (max-width: 630px) {
            margin: 10px 10px 10px 10px;
            text-align: left;
          }
        }
        .company-profile-option {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          .go-to-read-btn {
            background: #1885ad 0% 0% no-repeat padding-box;
            border-radius: 5px;
            padding: 10px 18px;
            font-size: 14px;
            margin-top: 13px;
            color: #fff;
            cursor: pointer;
            outline: none;
            width: 180px;
            margin-right: 20px;
            font-family: "AvenirBook";
            text-decoration: none;
            text-align: center;
          }
          .edit-btn {
            background: #ffffff 0% 0% no-repeat padding-box;
            border: 1px solid #ddd;
            border-radius: 5px;
            padding: 10px 18px;
            font-size: 14px;
            margin-top: 13px;
            color: #646262;
            cursor: pointer;
            outline: none;
            width: 180px;
            font-family: "AvenirBook";
            border: 1px solid #ccc;
          }
        }
      }
      .company-profile-options {
        .btn-edit-info {
          box-shadow: 0px 1px 3px #00000029;
          border: 1px solid #36adae;
          border-radius: 5px;
          color: #1885ad;
          padding: 10px 50px;
          font-family: "AvenirBook";
        }
      }
    }
    .company-profile-body {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      ul.consultants-items {
        padding-left: 0px;
        list-style: none;
        margin: 0px;
        .consultants-starter {
          margin-bottom: 6px;
          .consultants-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-bottom: 16px;
            label {
              color: #000000;
              font-family: "AvenirBook";
              font-size: 16px;
            }
            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;
              font-family: "AvenirBook";
              font-style: italic;
              background: transparent;
            }
          }
          p {
            color: #131313;
            font-family: "AvenirBook";
          }
        }
        .consultants-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          .consultants-item-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 9px 8px;
            .consultants-item-brand {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              img {
                width: 60px;
                height: 60px;
                object-fit: cover;
                margin-right: 15px;
                border-radius: 50%;
              }
            }
            .content {
              display: flex;
              flex-direction: column;
              width: 100%;
              justify-content: center;
              .title {
                display: flex;
                justify-content: space-between;
                width: 100%;
                font-family: "AvenirBook";
                label {
                  display: block;
                  font-size: 14px;
                  font-family: "AvenirBook";
                  margin-bottom: 7px;
                  font-weight: 500;
                }
              }
              span {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
                margin-bottom: 6px;
              }
              .date {
                color: #808080;
                font-family: "AvenirBook";
                font-size: 13px;
              }
            }
            .toogle-panel-btn {
              padding: 1px 40px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
            }
          }
        }
      }
      .empty-widget {
        .empty-widgetheader {
          label {
            font-size: 15px;
          }
        }
        .empty-widget-body {
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          h1 {
            margin-bottom: 30px;
          }
          p {
            text-align: center;
            width: 270px;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
    .company-profile-body {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      ul.project-items {
        padding-left: 0px;
        list-style: none;
        .project-starter {
          margin-bottom: 6px;
          .project-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0px;
            label {
              color: #000000;
              font-family: "AvenirBook";
              font-size: 16px;
            }
            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;
              font-family: "AvenirBook";
              font-style: italic;
              background: transparent;
            }
          }
          p {
            color: #131313;
            font-family: "AvenirBook";
          }
        }
        .project-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          .project-item-header {
            display: grid;
            padding: 17px 17px;
            grid-template-columns: 90px calc(98% - 90px);
            grid-column-gap: 20px;
            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 100%;
              padding: 10px 12px;
            }
            .project-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90px;
              height: 90px;
              background: rgb(228, 228, 228);
              border-radius: 50%;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 60px;
                height: 60px;
                display: none;
              }
              img {
                width: 70px;
                height: 70px;
                object-fit: contain;
                @media (min-width: 300px) and (max-width: 630px) {
                  width: 33px;
                  height: 33px;
                }
              }
            }
            .content {
              display: flex;
              justify-content: space-between;

              .title-row {
                font-family: "AvenirBook";
                padding-right: 9px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                label {
                  display: block;
                  font-size: 14px;
                  font-family: "AvenirBlack";
                  margin-bottom: 1px;
                  font-weight: 800;
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 12px;
                  }
                }

                span {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  margin-bottom: 6px;
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 12px;
                  }
                }
                .date {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  display: flex;
                  justify-content: flex-start;
                  align-items: center;
                  .separator {
                    margin: 0px 5px;
                  }
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 11px;
                  }
                }
              }
              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;
                .btns {
                  display: flex;
                  margin-top: -5px;
                  .verified-status {
                    color: #0590ab;
                    margin: 10px 0px;
                  }
                  .btn-verify {
                    height: 40px;
                    width: 100px;
                    outline: none;
                    color: #fff;
                    background-color: #1890a9;
                    border-radius: 5px;
                  }
                }

                .status {
                  color: #000;
                  font-family: "AvenirBook";
                  font-size: 13px;
                }

                .toogle-panel-btn {
                  width: 19px;
                  padding: 0;
                  height: 22px;
                  font-size: 20px;
                  position: absolute;
                  bottom: 5px;
                  right: 7px;
                }
              }
            }
            .toogle-panel-btn {
              padding: 1px 40px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
            }
          }
          .project-item-body {
            padding: 10px;
            h4 {
              font-family: "AvenirBook";
            }
            img {
              width: 100%;
            }
            p {
              font-size: 14px;
              font-family: "AvenirBook";
            }
            label {
              color: #808080;
              font-size: 15px;
              display: block;
              margin-bottom: 8px;
              font-family: "AvenirBook";
            }
            .skills-widget {
              display: flex;
              flex-wrap: wrap;
              .skill-item {
                background: #707070 0% 0% no-repeat padding-box;
                border-radius: 25px;
                color: #ffffff;
                font-size: 13px;
                font-family: "AvenirBook";
                padding: 5px 22px;
                margin-right: 10px;
                margin-bottom: 10px;
              }
            }
            .project-info {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              .col-one,
              .col-two {
                width: 50%;
                label {
                  color: #808080;
                  margin-bottom: 3px;
                  margin-top: 20px;
                }
                p {
                  color: #000;
                  margin: 0px;
                }
              }
            }
          }
        }
      }
      .empty-widget {
        .empty-widgetheader {
          label {
            font-size: 16px;
          }
        }
        .empty-widget-body {
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          padding: 0px 200px;
          p {
            text-align: center;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
  }
  .skills-section {
    border-radius: 5px;
    background: #ffffff;
    width: 300px;
    min-width: 300px;
    max-width: 400px;
    @media (min-width: 300px) and (max-width: 630px) {
      padding-bottom: 100px;
    }
    ul.skills-items {
      width: 100%;
      padding-left: 0px;
      list-style: none;
      .skills-starter {
        margin-bottom: 6px;
        .skills-item-header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 6px 15px;
          label {
            color: #000000;
            font-family: "AvenirBook";
            font-size: 16px;
          }
        }
      }
    }
    .skills-widget {
      padding: 0px 15px;
      .skills_content__wrapper {
        display: grid;
        grid-template-columns: 1fr;
        grid-column-gap: 10px;
        margin-bottom: 0px;

        .skill_box {
          min-width: 0;
          display: flex;
          flex-direction: column;
          width: 100%;
          background: #f5f5f5;
          border-radius: 5px;
          margin-bottom: 8px;
          .skill_box_header {
            border-bottom: 2px solid #efecec;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 0px 15px;
            label {
              color: #0884af;
              width: 100%;
              font-size: 15px;
              font-weight: 800;
            }
          }
          .skill_box_body {
            padding: 0px 15px;
            .empty-skills {
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 60px;
              justify-content: center;
              p {
                text-align: center;
                margin-bottom: 20px;
                color: #8d8d8d;
              }
              button {
                width: 133px;
                height: 36px;
                background: #1890a9 0% 0% no-repeat padding-box;
                border-radius: 5px;
                color: #fff;
              }
            }
            .row__item {
              margin-top: 10px;
              display: flex;
              margin-bottom: 10px;
              justify-content: space-between;
              width: 100%;
              span {
                color: #000000;
                font-weight: normal;
                margin-top: 2px;
                font-size: 14px;
              }
            }
          }
        }
      }
      .next_skills_content__wrapper {
        display: grid;
        grid-template-columns: 1fr;
        grid-column-gap: 10px;

        .skill_box {
          min-width: 0;
          display: flex;
          flex-direction: column;
          width: 100%;
          background: #f5f5f5;
          border-radius: 5px;
          margin-bottom: 8px;
          .skill_box_header {
            border-bottom: 2px solid #efecec;
            height: 50px;
            display: flex;
            align-items: center;
            justify-content: space-around;
            padding: 0px 15px;
            label {
              color: #0884af;
              width: 100%;
              font-size: 15px;
              font-weight: 800;
            }
          }
          .skill_box_body {
            padding: 0px 15px;
            .empty-skills {
              display: flex;
              flex-direction: column;
              align-items: center;
              height: 60px;
              justify-content: center;
              p {
                text-align: center;
                margin-bottom: 20px;
                color: #8d8d8d;
              }
              button {
                width: 133px;
                height: 36px;
                background: #1890a9 0% 0% no-repeat padding-box;
                border-radius: 5px;
                color: #fff;
              }
            }
            .row__item {
              margin-top: 10px;
              display: flex;
              margin-bottom: 10px;
              justify-content: space-between;
              width: 100%;
              span {
                color: #000000;
                font-weight: normal;
                margin-top: 2px;
                font-size: 14px;
              }
            }
          }
        }
      }
    }
  }
}

.input-flex {
  display: flex;
}
</style>